import { BLOCKCHAIN_NAME } from 'src/core/blockchain/models/blockchain-name';

import { UniZenCcrSupportedChain } from './unizen-ccr-supported-chains';

export type UniZenContractVersion = 'v1' | 'v2' | 'v3';

type UniZenContractAddresses = Record<
    UniZenContractVersion,
    Partial<Record<UniZenCcrSupportedChain, string>>
>;

export const uniZenContractAddresses: UniZenContractAddresses = {
    v1: {
        [BLOCKCHAIN_NAME.ETHEREUM]: '0xd3f64BAa732061F8B3626ee44bab354f854877AC',
        [BLOCKCHAIN_NAME.BINANCE_SMART_CHAIN]: '0x880E0cE34F48c0cbC68BF3E745F17175BA8c650e',
        [BLOCKCHAIN_NAME.POLYGON]: '0x07d0ac7671D4242858D0cebcd34ec03907685947',
        [BLOCKCHAIN_NAME.AVALANCHE]: '0x1C7F7e0258c81CF41bcEa31ea4bB5191914Bf7D7',
        [BLOCKCHAIN_NAME.FANTOM]: '0xBE2A77399Cde40EfbBc4e89207332c4a4079c83D',
        [BLOCKCHAIN_NAME.ARBITRUM]: '0x1C7F7e0258c81CF41bcEa31ea4bB5191914Bf7D7',
        [BLOCKCHAIN_NAME.OPTIMISM]: '0xad1D43efCF92133A9a0f33e5936F5ca10f2b012E',
        [BLOCKCHAIN_NAME.BASE]: '0x4F68248ecB782647D1E5981a181bBe1bfFee1040'
    },
    v2: {
        [BLOCKCHAIN_NAME.ETHEREUM]: '0xf140bE1825520F773Ff0F469786FCA65c876885f',
        [BLOCKCHAIN_NAME.BINANCE_SMART_CHAIN]: '0x12067e4473a1f00e58fa24e38e2cf3e53e21a33d',
        [BLOCKCHAIN_NAME.POLYGON]: '0x85f8fb7ac814d0a6a0b16bc207df5bbc631f1ca6',
        [BLOCKCHAIN_NAME.AVALANCHE]: '0x468ae09BD4c8B4D9f7601e37B6c061776FeCFE3B',
        [BLOCKCHAIN_NAME.FANTOM]: '0xD38559966E53B651794aD4df6DDc190d2235180E',
        [BLOCKCHAIN_NAME.ARBITRUM]: '0x9660b95fcDBA4B0f5917C47b703179E03a28bf27',
        [BLOCKCHAIN_NAME.OPTIMISM]: '0x3ce6e87922e62fc279152c841102eb2bf5497010'
    },
    v3: {
        [BLOCKCHAIN_NAME.ETHEREUM]: '0xCf2DBA4e5C9f1B47AC09dc712A0F7bD8eE31A15d',
        [BLOCKCHAIN_NAME.BINANCE_SMART_CHAIN]: '0xa9c430de6a91132330A09BE41f9f19bf45702f74',
        [BLOCKCHAIN_NAME.POLYGON]: '0xCf2DBA4e5C9f1B47AC09dc712A0F7bD8eE31A15d',
        [BLOCKCHAIN_NAME.AVALANCHE]: '0xa9c430de6a91132330A09BE41f9f19bf45702f74',
        [BLOCKCHAIN_NAME.ARBITRUM]: '0xa9c430de6a91132330A09BE41f9f19bf45702f74',
        [BLOCKCHAIN_NAME.OPTIMISM]: '0xa9c430de6a91132330A09BE41f9f19bf45702f74',
        [BLOCKCHAIN_NAME.BASE]: '0xa9c430de6a91132330A09BE41f9f19bf45702f74'
    }
};
